export const TONE_SELECT_OPTIONS = [
  {
    label: 'Дружелюбный (тёплый, неформальный)',
    value: 'friendly',
  },
  {
    label: 'Формальный (на Вы, без эмодзи)',
    value: 'formal',
  },
  {
    label: 'Игривый (с юмором)',
    value: 'playful',
  },
];
